import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import NewOrganization from './components/NewOrganization';
import EditOrganization from './components/EditOrganization';
import OrganizationsList from './components/OrganizationsList';

const Organizations = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [editOrganizationId, setEditOrganizationId] = useState();
  const setEditOrganizationIdHandler = (organization_id) => setEditOrganizationId(organization_id);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Organizations Management</h3>
          <h3 className="page-subhead subhead">Manage workspace organizations</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <OrganizationsList setEditOrganizationIdHandler={setEditOrganizationIdHandler} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload}/>
        </Col>
        <Col md={4}>
          {!editOrganizationId && <NewOrganization setListRequiresReload={setListRequiresReload}/>}
          {editOrganizationId && <EditOrganization organization_id={editOrganizationId} setListRequiresReload={setListRequiresReload} setEditOrganizationIdHandler={setEditOrganizationIdHandler}/>}
        </Col>
      </Row>
    </Container>
  );
};

export default Organizations;